import { render, staticRenderFns } from "./ContactChip.vue?vue&type=template&id=255794d5&scoped=true"
import script from "./ContactChip.vue?vue&type=script&lang=js"
export * from "./ContactChip.vue?vue&type=script&lang=js"
import style0 from "./ContactChip.vue?vue&type=style&index=0&id=255794d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255794d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VChip,VHover,VIcon})
